import { useNavigate } from "react-router-dom"

import "../../styles/NavBar.css"

function NavBarOrder({ cartModal, setCartModal, adminButton, setWarnNav, setWarnModal }) {
  const navigate = useNavigate()

  const handleWarnModal = nav => {
    setWarnNav(nav)
    setWarnModal(true)
  }
  
  return (
    <div className="navbar-container" >

      <div className="navbar-panel-1">  
        {!adminButton ?
          <>
            <div className="navbar-link-container" onClick={(() => handleWarnModal("/order/dining"))} >
              <span className="navbar-link" >Dining</span>
            </div>
            <div className="navbar-link-container-x" onClick={(() => handleWarnModal("/order/catering"))} >
              <span className="navbar-link" >Catering / Banquet</span>
            </div>
          </>
        : null}
      </div> 

      <div className="navbar-panel-2">
        {!adminButton ?
          <button className="navbar-button" onClick={() => setCartModal(!cartModal)} >Checkout</button> :

          adminButton === "Back to menu" ?
            <button className="navbar-button-ad" onClick={() => navigate("/order/dining")} >{adminButton}</button> :
            <button className="navbar-button-ad" onClick={() => navigate("/order/admin")} >{adminButton}</button>
        }
      </div>

      <div className="navbar-panel-3">
        {!adminButton ?
        <>
          <div className="navbar-link-container" onClick={(() => handleWarnModal("/home"))} >
            <span className="navbar-link" >Home</span>
          </div>
          <div className="navbar-link-container" onClick={(() => handleWarnModal("/about"))} >
            <span className="navbar-link" >About Us</span>
          </div>
          <div className="navbar-link-container" onClick={(() => handleWarnModal("/contact"))} >
            <span className="navbar-link" >Contact</span>
          </div>
        </>
        : null}
      </div>            
    </div>
  )
}

export default NavBarOrder
